import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment, forwardRef, useCallback, useRef } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { BKJCheck } from '../BKJCheckbox/src/BKJCheck.js';
import { BKJToggleButton, BKJToggleInputPillCheckDisplay, BKJToggleInputPillLabelWrapper, BKJToggleInputSwitchInput, BKJToggleInputWrapper, BKJToggleSliderTrack, StyledButton, } from './BKJToggleInput.styled.js';
const BKJToggleInputSwitch = forwardRef(({ onChange, name, checked, disabled, variant: _variant, children: _children, ...rest }, ref) => {
    const idRef = useRef(`bkj-toggle-${uuidv4()}`);
    const handleNativeChange = (event) => {
        onChange({
            ...event,
            target: { ...event.target, name, value: event.target.checked },
        });
    };
    return (_jsxs(BKJToggleInputWrapper, { htmlFor: idRef.current, children: [_jsx(BKJToggleInputSwitchInput, { ...rest, type: "checkbox", id: idRef.current, name: name, checked: !!checked, disabled: disabled, onChange: handleNativeChange, ref: ref }), _jsx(BKJToggleSliderTrack, { "aria-hidden": "true", isSelected: !!checked, disabled: disabled }), _jsx(BKJToggleButton, { "aria-hidden": "true", isSelected: !!checked, disabled: disabled })] }));
});
const BKJToggleInputPill = ({ variant, onChange, width, minWidth, checked, children, disabled, name, fontSize, }) => {
    const handleChange = useCallback((event) => {
        if (!disabled) {
            const nextValue = !checked;
            onChange({
                ...event,
                target: {
                    ...event.target,
                    name,
                    value: nextValue,
                    checked: nextValue,
                },
            });
        }
    }, [disabled, checked, onChange, name]);
    const ButtonVariantMap = {
        PurplePillLeft: checked ? 'PurplePill' : 'PurplePillOutlined',
        PurplePillRight: checked ? 'PurplePill' : 'PurplePillOutlined',
        PurpleNoBorderLeft: 'NoStyles',
        PurpleNoBorderRight: 'NoStyles',
        Switch: 'NoStyles',
    };
    const innerCheckVariant = variant === 'PurplePillLeft' || variant === 'PurplePillRight'
        ? 'PurpleOutlined'
        : 'PurpleSolid';
    return (_jsx(StyledButton, { onClick: handleChange, variant: ButtonVariantMap[variant], width: width, minWidth: minWidth, disabled: disabled, role: "switch", "aria-checked": !!checked, "aria-disabled": disabled || undefined, children: (() => {
            switch (variant) {
                case 'PurplePillLeft':
                case 'PurplePillRight':
                    return (_jsxs(Fragment, { children: [variant === 'PurplePillLeft' && (_jsx(BKJToggleInputPillLabelWrapper, { fontSize: fontSize, children: children })), _jsx(BKJToggleInputPillCheckDisplay, { "aria-hidden": "true", variant: variant, checked: !!checked, disabled: disabled, children: _jsx(BKJCheck, { variant: innerCheckVariant, checked: !!checked, disabled: disabled }) }), variant === 'PurplePillRight' && (_jsx(BKJToggleInputPillLabelWrapper, { fontSize: fontSize, children: children }))] }));
                case 'PurpleNoBorderLeft':
                case 'PurpleNoBorderRight':
                    return (_jsxs(Fragment, { children: [variant === 'PurpleNoBorderLeft' && (_jsx(BKJToggleInputPillLabelWrapper, { color: "PrimaryDefault", disabled: disabled, fontSize: fontSize, children: children })), _jsx(BKJToggleInputPillCheckDisplay, { "aria-hidden": "true", variant: variant, checked: !!checked, disabled: disabled, children: _jsx(BKJCheck, { variant: innerCheckVariant, checked: !!checked, disabled: disabled }) }), variant === 'PurpleNoBorderRight' && (_jsx(BKJToggleInputPillLabelWrapper, { color: "PrimaryDefault", disabled: disabled, fontSize: fontSize, children: children }))] }));
                case 'Switch':
                default:
                    return _jsx(Fragment, {});
            }
        })() }));
};
export const BKJToggleInputComponentMap = {
    Switch: BKJToggleInputSwitch,
    PurplePillRight: BKJToggleInputPill,
    PurplePillLeft: BKJToggleInputPill,
    PurpleNoBorderRight: BKJToggleInputPill,
    PurpleNoBorderLeft: BKJToggleInputPill,
};
//# sourceMappingURL=BKJToggleInput.constants.js.map